import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useMutation } from '@tanstack/react-query'
import { resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostMutation } from '@/generated/@tanstack/react-query.gen'
import { toast } from '@/components/custom-toast'
import { useUser } from '@/pages/enterprise/user-provider'

interface IProps {
  organizationId: number
  userId: string
  email: string
  open: boolean
  setOpen: (open: boolean) => void
  isHiddenTrigger?: boolean
  disabled?: boolean
}

export default function ResendInvitationModal(props: IProps) {
  const { open, setOpen, isHiddenTrigger, disabled } = props
  const { onUpdateSeats } = useUser()
  const mutate = useMutation({
    ...resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostMutation(
      {}
    ),
    onError: (error) => {
      toast.error({
        message:
          (error.response?.data.detail as unknown as string) ?? error.message,
      })
    },
    onSuccess: () => {
      onUpdateSeats()
      toast.success({
        message: 'Invitation re-sent successfully.',
      })
      setOpen(false)
    },
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {isHiddenTrigger ? null : (
        <DialogTrigger asChild>
          <Button disabled={disabled} size={'sm'} variant={'window'}>
            Resend Invitation
          </Button>
        </DialogTrigger>
      )}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Resend Invitation</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          We’ll send another invitation link to{' '}
          <span className="font-bold">{props.email}</span>. This link is valid
          for 24 hours.
        </DialogDescription>

        <DialogFooter className="flex !justify-start">
          <Button
            disabled={mutate.isPending}
            onClick={() => {
              mutate.mutate({
                path: {
                  organization_id: props.organizationId,
                  useruuid: props.userId,
                },
              })
            }}
            className=""
          >
            Send
          </Button>
          <DialogClose asChild>
            <Button
              variant="ghost"
              className="text-primary hover:text-emerald-500 hover:bg-transparent"
            >
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
